import React from "react";
import ArrowLeft from "@strapi/icons/ArrowLeft";
import { Icon } from "@strapi/design-system/Icon";
import { Typography } from "@strapi/design-system/Typography";
import { useHistory } from "react-router-dom";
import styles from "./Back.module.css";

const Back = ({ customGoBack }) => {
  const history = useHistory();

  const handleClick = () => {
    if (customGoBack) return customGoBack(history);
    history.goBack();
  };

  return (
    <div className={styles.back} onClick={handleClick}>
      <Icon color="primary600" as={ArrowLeft} />

      <Typography variant="pi" textColor="primary600">
        Back
      </Typography>
    </div>
  );
};

export default Back;
